import { useEffect } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function RunaPortfolio() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-gray-200 selection:text-black">
      <title>Runa | Optimización Web y Localización | Mood Agency</title>
      <meta name="description" content="Caso de éxito Runa: Reconstrucción de sitio WordPress con Elementor, implementación de multilenguaje, y optimización técnica para SEO y velocidad de carga." />
      <meta name="keywords" content="Runa, WordPress, Elementor, SEO, Page Speed, Localización, Traducción, Desarrollo Web" />
      
      <Navbar />
      
      {/* Hero Section - Clean & Minimal */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-white">
        {/* Background Ripple Effect */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <div className="absolute w-[60vw] h-[60vw] bg-[radial-gradient(circle,var(--tw-gradient-stops))] from-blue-100 via-gray-100/50 to-transparent rounded-full blur-[80px] opacity-100 z-0"></div>
          <div className="w-[90vw] h-[90vw] border border-gray-200 rounded-full absolute opacity-40"></div>
          <div className="w-[70vw] h-[70vw] border border-gray-300 rounded-full absolute opacity-50"></div>
          <div className="w-[50vw] h-[50vw] border border-gray-300 rounded-full absolute opacity-60"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 text-center">
          <div className="mb-8 animate-fade-in-up">
            <span className="font-display text-[10px] tracking-[0.4em] text-gray-400 uppercase">
              CASO DE ÉXITO
            </span>
          </div>
          
          <h1 className="font-display text-[12vw] md:text-[8vw] leading-none font-bold uppercase tracking-tighter text-gray-900 mb-8 animate-fade-in-up delay-100">
            Runa
          </h1>
          
          <p className="max-w-2xl mx-auto font-sans text-xl text-gray-500 font-light leading-relaxed animate-fade-in-up delay-200">
            Reinvención digital: Optimización, localización y escalabilidad global.
          </p>
        </div>
      </section>

      {/* Key Metrics */}
      <section className="py-20 px-6 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">98/100</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Page Speed Score</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">100%</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">SEO Score</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">Multi</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Idiomas & Localización</p>
          </div>
        </div>
      </section>

      {/* The Context */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-12 uppercase">El Contexto</h2>
          <p className="font-sans text-xl md:text-2xl text-gray-500 leading-relaxed font-light">
            Runa contaba con una instalación de WordPress rígida y difícil de administrar. La falta de optimización afectaba su posicionamiento en buscadores y la experiencia de usuario era lenta. Además, la expansión global requería una solución robusta de localización.
          </p>
        </div>
      </section>

      {/* The Challenge */}
      <section className="py-32 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-20 items-center">
          <div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase leading-tight">
              Desafío<br/>Técnico
            </h2>
            <p className="font-sans text-lg text-gray-500 leading-relaxed mb-12">
              El objetivo principal era modernizar la plataforma sin perder la esencia, permitiendo una gestión de contenido ágil a través de Elementor, y asegurando que el sitio pudiera escalar y responder rápidamente en múltiples regiones.
            </p>
          </div>
          <div className="space-y-12">
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Gestión de Contenido</h3>
              <p className="font-sans text-gray-500">Migración a una estructura flexible con Elementor para facilitar la edición.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Internacionalización</h3>
              <p className="font-sans text-gray-500">Implementación de traducción y localización completa para audiencia global.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Rendimiento</h3>
              <p className="font-sans text-gray-500">Optimización de concurrencia y escalabilidad para lograr puntuaciones perfectas en Page Speed y SEO.</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Solution */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-20">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 uppercase">La Solución</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Reingeniería WordPress</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Rehicimos la instalación de WordPress desde cero, integrando Elementor Pro para otorgar control total sobre el diseño y facilitar futuras actualizaciones sin código.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Localización Avanzada</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Implementamos un sistema de traducción y localización robusto, adaptando no solo el idioma sino también el contenido culturalmente relevante para cada región.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">SEO & Performance</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Optimizamos la carga de recursos, implementamos caché avanzado y aseguramos la concurrencia, logrando puntuaciones altas en herramientas de SEO y velocidad.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact */}
      <section className="py-32 px-6 bg-black text-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-20 uppercase tracking-widest">Resultado</h2>
          
          <div className="max-w-4xl mx-auto">
            <p className="font-display text-2xl md:text-4xl leading-tight mb-12">
              "Una plataforma rápida, escalable y global. Runa ahora compite en los primeros lugares de búsqueda con una experiencia de usuario fluida en cualquier idioma."
            </p>
            <div className="w-20 h-1 bg-white mx-auto opacity-30"></div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
